import EventBus from '@/services/event-bus';
import db from '../db';

function normalizeValue(value) {
  return String(value ?? '').trim();
}

function dedupeAddressItems(items = []) {
  const seen = new Set();

  return items.filter((item) => {
    const key = [
      item?.id,
      item?.companyId,
      item?.addressCompany,
      item?.companyName,
      item?.addressCode,
      item?.name,
    ]
      .map(normalizeValue)
      .join('||');

    if (seen.has(key)) {
      return false;
    }

    seen.add(key);
    return true;
  });
}

function dedupeClientMenuItems(items = []) {
  const seen = new Set();

  return items
    .map((item) => ({
      ...item,
      itemsData: Array.isArray(item?.itemsData)
        ? dedupeAddressItems(item.itemsData)
        : item?.itemsData,
    }))
    .filter((item) => {
      const key = [
        item?.id,
        item?.companyId,
        item?.addressCompany,
        item?.companyCode,
        item?.companyName,
        item?.addressCode,
        item?.addressName,
        item?.name,
        item?.contactIndex,
      ]
        .map(normalizeValue)
        .join('||');

      if (seen.has(key)) {
        return false;
      }

      seen.add(key);
      return true;
    });
}

export default {
  namespaced: true,
  state: {
    items: [],
    currentAddress: '',
  },
  getters: {
    items: (state) => state.items,
  },
  actions: {
    setItems({ commit }, value) {
      commit('setItems', value);
    },
    setAddress({ commit, rootState }) {
      commit('setCurrentAddress', `${rootState.contact.addressName}`);

      setTimeout(() => {
        if (rootState.contact.enabled) {
          EventBus.$emit('onChangeCompany', true);
        }
      }, 0);
    },
  },
  mutations: {
    setItems(state, value) {
      const normalizedItems = dedupeClientMenuItems(value);
      state.items = normalizedItems;

      if (normalizedItems.length === 0) {
        return;
      }

      if (normalizedItems[0]?.companyId == null) {
        db.headquarters.clear().then(() => {
          db.headquarters.bulkPut(normalizedItems);
        });
      } else {
        db.contacts.clear().then(() => {
          db.contacts.bulkPut(normalizedItems);
        });
      }
    },
    setCurrentAddress(state, value) {
      state.currentAddress = value;
    },
  },
};
